import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-md w-full" }
const _hoisted_3 = { class: "bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between rounded-t-lg" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_6 = { class: "px-6 py-5" }
const _hoisted_7 = { class: "flex items-center justify-end space-x-3 px-6 py-4 border-t border-gray-200 dark:border-gray-700 rounded-b-lg" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, watch } from 'vue';
import type { Customer, CustomerCategoryUpdateData } from '@/types/customer';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerCategoryModal',
  props: {
    isOpen: { type: Boolean },
    customer: {},
    loading: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedCategory = ref<'customer' | 'internal'>('customer');

// Sync dropdown to current customer category when modal opens
watch(
  () => props.customer,
  (newCustomer) => {
    if (newCustomer) {
      selectedCategory.value = newCustomer.category ?? 'customer';
    }
  },
  { immediate: true }
);

function handleSubmit() {
  emit('submit', { category: selectedCategory.value });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen && _ctx.customer)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/20 flex items-center justify-center mr-3" }, [
                        _createElementVNode("svg", {
                          class: "h-5 w-5 text-blue-600 dark:text-blue-400",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                          })
                        ])
                      ], -1)),
                      _createElementVNode("div", null, [
                        _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, "Update Category", -1)),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.customer.first_name) + " " + _toDisplayString(_ctx.customer.last_name), 1)
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _cache[8] || (_cache[8] = _createElementVNode("label", {
                      for: "category",
                      class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                    }, " Category ", -1)),
                    _withDirectives(_createElementVNode("select", {
                      id: "category",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedCategory).value = $event)),
                      class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white"
                    }, _cache[7] || (_cache[7] = [
                      _createElementVNode("option", { value: "customer" }, "Customer", -1),
                      _createElementVNode("option", { value: "internal" }, "Internal", -1)
                    ]), 512), [
                      [_vModelSelect, selectedCategory.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
                      disabled: _ctx.loading,
                      class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                    }, " Cancel ", 8, _hoisted_8),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: handleSubmit,
                      disabled: _ctx.loading,
                      class: "px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
                    }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[9] || (_cache[9] = [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }, null, -1),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            }, null, -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Saving...' : 'Save'), 1)
                    ], 8, _hoisted_9)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})